import {
  UnifiedThemeProvider,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';

/** Palette of the Gobierno de México graphic guide (gob.mx). */
const gob = {
  guinda: '#611232',
  guindaClaro: '#9D2449',
  guindaOscuro: '#4A0E26',
  dorado: '#A57F2C',
  doradoClaro: '#BC955C',
  verde: '#002F2A',
  gris: '#98989A',
  negro: '#161A1D',
};

const pageTheme = (colors: [string, string]) =>
  genPageTheme({ colors, shape: shapes.wave });

const pageThemes = {
  home: pageTheme([gob.guinda, gob.guindaClaro]),
  documentation: pageTheme([gob.verde, '#13322B']),
  tool: pageTheme([gob.dorado, gob.doradoClaro]),
  service: pageTheme([gob.guinda, gob.guindaClaro]),
  website: pageTheme([gob.guinda, gob.guindaClaro]),
  library: pageTheme([gob.dorado, gob.doradoClaro]),
  other: pageTheme([gob.guinda, gob.guindaClaro]),
  app: pageTheme([gob.guinda, gob.guindaClaro]),
  apis: pageTheme([gob.verde, '#13322B']),
};

const lightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: gob.guindaClaro, dark: gob.guinda },
    secondary: { main: gob.dorado },
    banner: {
      ...palettes.light.banner,
      info: gob.verde,
      link: gob.doradoClaro,
    },
    navigation: {
      ...palettes.light.navigation,
      background: gob.guinda,
      indicator: gob.doradoClaro,
      color: '#FFFFFF',
      selectedColor: '#FFFFFF',
      navItem: { hoverBackground: gob.guindaClaro },
      submenu: { background: gob.guindaOscuro },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: pageThemes,
});

const darkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: gob.doradoClaro, dark: gob.dorado },
    secondary: { main: gob.guindaClaro },
    navigation: {
      ...palettes.dark.navigation,
      background: gob.guindaOscuro,
      indicator: gob.doradoClaro,
      color: '#FFFFFF',
      selectedColor: '#FFFFFF',
      navItem: { hoverBackground: gob.guinda },
      submenu: { background: gob.negro },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: pageThemes,
});

// Same ids as the Backstage defaults: these replace them, so the theme switcher keeps working.
export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'light',
      params: {
        theme: {
          id: 'light',
          title: 'Claro',
          variant: 'light',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={lightTheme}>
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'dark',
      params: {
        theme: {
          id: 'dark',
          title: 'Oscuro',
          variant: 'dark',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={darkTheme}>
              {children}
            </UnifiedThemeProvider>
          ),
        },
      },
    }),
  ],
});
